import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  loginUser,
  getCurrentFinancialYear,
  sendForgotPasswordOtp,
  verifyForgotPasswordOtp,
  resetForgotPassword,
} from "../../services/auth_service";
import "./Login.css";
export default function Login() {
  const navigate = useNavigate();
  const location = useLocation();
  const [form, setForm] = useState({
    mobile: "",
    password: "",
  });
  const [currentFY, setCurrentFY] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showSessionModal, setShowSessionModal] = useState(false);
  const [forceLoading, setForceLoading] = useState(false);
  const [showForgotPassword, setShowForgotPassword] = useState(false);
  const [forgotStep, setForgotStep] = useState("mobile");
  const [forgotMobile, setForgotMobile] = useState("");
  const [forgotOtp, setForgotOtp] = useState("");
  const [forgotNewPassword, setForgotNewPassword] = useState("");
  const [forgotConfirmPassword, setForgotConfirmPassword] = useState("");
  const [forgotVerificationId, setForgotVerificationId] = useState("");
  const [forgotOtpVerified, setForgotOtpVerified] = useState(false);
  const [forgotLoading, setForgotLoading] = useState(false);
  const [forgotResetLoading, setForgotResetLoading] = useState(false);
  const idleLoggedOut = location.state?.reason === "idle_timeout";
  useEffect(() => {
    fetchCurrentFinancialYear();
  }, []);
  const fetchCurrentFinancialYear = async () => {
    try {
      const fy = await getCurrentFinancialYear();
      setCurrentFY(fy);
    } catch (err) {
      console.error("Unable to load current financial year:", err);
    }
  };
  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };
  const applySession = (res) => {
    localStorage.setItem("token", res.access_token);
    localStorage.setItem("user", JSON.stringify(res));
    localStorage.setItem("user_id", res.user_id);
    localStorage.setItem("role_id", res.role_id);
    localStorage.setItem("role_name", res.role_name);
    localStorage.setItem("full_name", res.full_name);
    localStorage.setItem("mobile", res.mobile);
    localStorage.setItem("permissions", JSON.stringify(res.permissions));
    localStorage.setItem("financial_year_id", res.financial_year_id ?? "");
    localStorage.setItem("financial_year_label", res.financial_year_label ?? "");
  };
  const finishLogin = (res) => {
    applySession(res);
    navigate("/dashboard");
  };
  const handleLogin = async (e) => {
    e.preventDefault();
    if (!form.mobile.trim() || !form.password) {
      alert("Please enter mobile number and password");
      return;
    }
    try {
      setLoading(true);
      const res = await loginUser(form.mobile, form.password, null, false);
      if (res.success === false && res.session_exists) {
        setShowSessionModal(true);
        return;
      }
      finishLogin(res);
    } catch (error) {
      alert(error?.response?.data?.detail || "Login Failed");
    } finally {
      setLoading(false);
    }
  };
  const handleForceLogin = async () => {
    try {
      setForceLoading(true);
      const res = await loginUser(form.mobile, form.password, null, true);
      setShowSessionModal(false);
      finishLogin(res);
    } catch (error) {
      alert(error?.response?.data?.detail || "Login Failed");
    } finally {
      setForceLoading(false);
    }
  };
  const openForgotPassword = () => {
    setForgotMobile(form.mobile || "");
    setForgotOtp("");
    setForgotNewPassword("");
    setForgotConfirmPassword("");
    setForgotVerificationId("");
    setForgotOtpVerified(false);
    setForgotStep("mobile");
    setShowForgotPassword(true);
  };
  const closeForgotPassword = () => {
    if (forgotLoading || forgotResetLoading) {
      return;
    }
    setShowForgotPassword(false);
  };
  const handleSendForgotOtp = async () => {
    const mobile = forgotMobile.replace(/\D/g, "");
    if (mobile.length !== 10) {
      alert("Please enter a valid 10-digit mobile number");
      return;
    }
    try {
      setForgotLoading(true);
      const res = await sendForgotPasswordOtp(mobile);
      setForgotMobile(mobile);
      setForgotVerificationId(res.verification_id || "");
      setForgotOtp("");
      setForgotOtpVerified(false);
      setForgotStep("otp");
      alert(res.message || "OTP sent successfully");
    } catch (error) {
      alert(error?.response?.data?.detail || "Unable to send OTP");
    } finally {
      setForgotLoading(false);
    }
  };
  const handleVerifyForgotOtp = async () => {
    const mobile = forgotMobile.replace(/\D/g, "");
    const otp = forgotOtp.replace(/\D/g, "");
    if (mobile.length !== 10) {
      alert("Please enter a valid 10-digit mobile number");
      return;
    }
    if (otp.length !== 6) {
      alert("Please enter the 6-digit OTP");
      return;
    }
    if (!forgotVerificationId) {
      alert("Please request a new OTP");
      return;
    }
    try {
      setForgotLoading(true);
      const res = await verifyForgotPasswordOtp(
        mobile,
        otp,
        forgotVerificationId
      );
      setForgotOtp(otp);
      setForgotOtpVerified(true);
      setForgotStep("password");
      alert(res.message || "OTP verified successfully");
    } catch (error) {
      alert(error?.response?.data?.detail || "Invalid OTP");
    } finally {
      setForgotLoading(false);
    }
  };
  const handleResetPassword = async (e) => {
    e.preventDefault();
    const mobile = forgotMobile.replace(/\D/g, "");
    const otp = forgotOtp.replace(/\D/g, "");
    if (!forgotOtpVerified) {
      alert("Please verify OTP first");
      return;
    }
    if (forgotNewPassword.length < 6) {
      alert("Password must be at least 6 characters");
      return;
    }
    if (forgotNewPassword !== forgotConfirmPassword) {
      alert("New Password and Confirm Password do not match");
      return;
    }
    try {
      setForgotResetLoading(true);
      const res = await resetForgotPassword(
        mobile,
        otp,
        forgotVerificationId,
        forgotNewPassword,
        forgotConfirmPassword
      );
      alert(res.message || "Password reset successfully");
      setShowForgotPassword(false);
      setForgotStep("mobile");
      setForgotMobile("");
      setForgotOtp("");
      setForgotNewPassword("");
      setForgotConfirmPassword("");
      setForgotVerificationId("");
      setForgotOtpVerified(false);
      setForm({
        mobile,
        password: "",
      });
    } catch (error) {
      alert(error?.response?.data?.detail || "Unable to reset password");
    } finally {
      setForgotResetLoading(false);
    }
  };
  const features = [
    "Driver Management",
    "Vehicle Management",
    "Supplier Management",
    "Vehicle Allotment",
    "Reports & Dashboard",
  ];
  return (
    <div className="login-page">
      <div className="login-container">
        <div className="login-left">
          <div className="left-content">
            <div className="logo-circle">
              <img
                src="/assets/logo.jpg"
                alt="FleetPro Logo"
                className="logo-circle-img"
              />
            </div>
            <h2>Fleet Management Pro</h2>
            <span className="company-text">Smart Transport Solution</span>
            <div className="line"></div>
            <div className="route-map">
              <span className="route-marker" aria-hidden="true"></span>
              <ul className="feature-list">
                {features.map((f) => (
                  <li className="feature-item" key={f}>
                    {f}
                  </li>
                ))}
              </ul>
            </div>
            <div className="route-divider" aria-hidden="true"></div>
            <div className="company-address">
              <span className="address-eyebrow">Address</span>
              <p className="address-name">
                Srinivasa Tours &amp; Travels
              </p>
              <p className="address-lines">
                Plot No.275, CBI Colony, Near Red Water Tank,
                <br />
                NGO&apos;s Colony, Vanasthalipuram,
                <br />
                Hyderabad&nbsp;500070
              </p>
            </div>
          </div>
        </div>
        <div className="login-right">
          <div className="login-card">
            <div className="heading-section">
              <div className="heading-text">
                <h2>Welcome Back</h2>
                <p>Login to your Fleet Management Pro Portal</p>
              </div>
              <img
                src="/assets/logo2.jpg"
                alt="Company Logo"
                className="welcome-logo"
              />
            </div>
            {idleLoggedOut && (
              <div className="idle-note" role="status">
                <span className="idle-note-icon" aria-hidden="true">
                  🔒
                </span>
                <span className="idle-note-text">
                  For your security, you were signed out after some time away.
                  Just log in again to continue.
                </span>
              </div>
            )}
            <form onSubmit={handleLogin}>
              <div className="form-group">
                <label>Mobile Number</label>
                <input
                  type="text"
                  name="mobile"
                  placeholder="Enter Mobile Number"
                  value={form.mobile}
                  onChange={handleChange}
                  autoComplete="tel"
                  maxLength={10}
                />
              </div>
              <div className="form-group">
                <label>Password</label>
                <input
                  type="password"
                  name="password"
                  placeholder="Enter Password"
                  value={form.password}
                  onChange={handleChange}
                  autoComplete="current-password"
                />
              </div>
              <div className="forgot-password-row">
                <button
                  type="button"
                  className="forgot-password-link"
                  onClick={openForgotPassword}
                >
                  Forgot Password?
                </button>
              </div>
              <button
                className="login-btn"
                disabled={loading}
                type="submit"
              >
                {loading ? "Logging In…" : "Login"}
              </button>
              <button type="button" className="return-home-link" onClick={() => navigate("/")}>← Return Home</button>
              <div className="copyright">© 2026 Srinivasa Tours &amp; Travels. All Rights Reserved.</div>
            </form>
          </div>
        </div>
      </div>
      {showSessionModal && (
        <div className="session-modal-overlay">
          <div className="session-modal">
            <div className="session-modal-icon" aria-hidden="true">🔐</div>
            <h3>Already Logged In</h3>
            <p>
              This account is already logged in on another device. Logging in
              here will log out that device.
            </p>
            <div className="session-modal-actions">
              <button
                type="button"
                className="session-modal-cancel"
                onClick={() => setShowSessionModal(false)}
                disabled={forceLoading}
              >
                Cancel
              </button>
              <button
                type="button"
                className="session-modal-confirm"
                onClick={handleForceLogin}
                disabled={forceLoading}
              >
                {forceLoading ? "Logging In…" : "Login Here"}
              </button>
            </div>
          </div>
        </div>
      )}
      {showForgotPassword && (
        <div className="forgot-password-overlay">
          <div className="forgot-password-modal">
            <button
              type="button"
              className="forgot-password-close"
              onClick={closeForgotPassword}
              disabled={forgotLoading || forgotResetLoading}
              aria-label="Close"
            >
              ×
            </button>
            {forgotStep === "mobile" && (
              <>
                <div className="forgot-password-icon">🔐</div>
                <h3>Forgot Password?</h3>
                <p>
                  Enter your registered mobile number to receive an OTP.
                </p>
                <div className="form-group">
                  <label>Mobile Number</label>
                  <input
                    type="text"
                    value={forgotMobile}
                    onChange={(e) =>
                      setForgotMobile(
                        e.target.value.replace(/\D/g, "").slice(0, 10)
                      )
                    }
                    placeholder="Enter 10-digit mobile number"
                    autoComplete="tel"
                    maxLength={10}
                    autoFocus
                  />
                </div>
                <button
                  type="button"
                  className="forgot-primary-btn"
                  onClick={handleSendForgotOtp}
                  disabled={forgotLoading}
                >
                  {forgotLoading ? "Sending OTP…" : "Send OTP"}
                </button>
              </>
            )}
            {forgotStep === "otp" && (
              <>
                <div className="forgot-password-icon">📱</div>
                <h3>Verify OTP</h3>
                <p>
                  Enter the 6-digit OTP sent to your mobile number.
                </p>
                <div className="form-group">
                  <label>OTP</label>
                  <input
                    type="text"
                    value={forgotOtp}
                    onChange={(e) =>
                      setForgotOtp(
                        e.target.value.replace(/\D/g, "").slice(0, 6)
                      )
                    }
                    placeholder="Enter 6-digit OTP"
                    inputMode="numeric"
                    maxLength={6}
                    autoFocus
                  />
                </div>
                <button
                  type="button"
                  className="forgot-primary-btn"
                  onClick={handleVerifyForgotOtp}
                  disabled={forgotLoading}
                >
                  {forgotLoading ? "Verifying…" : "Verify OTP"}
                </button>
                <button
                  type="button"
                  className="forgot-secondary-btn"
                  onClick={() => {
                    setForgotStep("mobile");
                    setForgotOtp("");
                    setForgotVerificationId("");
                    setForgotOtpVerified(false);
                  }}
                  disabled={forgotLoading}
                >
                  Change Mobile / Resend OTP
                </button>
              </>
            )}
            {forgotStep === "password" && (
              <>
                <div className="forgot-password-icon">🔑</div>
                <h3>Create New Password</h3>
                <p>
                  Your mobile number has been verified. Set a new password.
                </p>
                <form onSubmit={handleResetPassword}>
                  <div className="form-group">
                    <label>New Password</label>
                    <input
                      type="password"
                      value={forgotNewPassword}
                      onChange={(e) =>
                        setForgotNewPassword(e.target.value)
                      }
                      placeholder="Enter new password"
                      autoComplete="new-password"
                      minLength={6}
                      autoFocus
                    />
                  </div>
                  <div className="form-group">
                    <label>Confirm Password</label>
                    <input
                      type="password"
                      value={forgotConfirmPassword}
                      onChange={(e) =>
                        setForgotConfirmPassword(e.target.value)
                      }
                      placeholder="Confirm new password"
                      autoComplete="new-password"
                      minLength={6}
                    />
                  </div>
                  <button
                    type="submit"
                    className="forgot-primary-btn"
                    disabled={forgotResetLoading}
                  >
                    {forgotResetLoading
                      ? "Resetting Password…"
                      : "Reset Password"}
                  </button>
                </form>
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
